import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import DateInterval from 'src/components/Conversion/DateInterval';
import translation from 'src/components/translation';
import type { ResumeCardData } from 'src/models/resumeCard';

import Field from 'src/components/ResumeCard/Body/Field';

const TrlKeys = {
    totalExperience: 'employer.resumesSearch.experience.period',
};

const TotalExperience: TranslatedComponent<{ resume: ResumeCardData }> = ({ resume, trls }) => {
    const totalExperience = resume.totalExperience?.[0]?.string;
    if (!totalExperience) {
        return null;
    }
    return (
        <Field title={trls[TrlKeys.totalExperience]} dataQaName="total-experience">
            <DateInterval years={Math.floor(totalExperience / 12)} months={totalExperience % 12} />
        </Field>
    );
};

export default translation(TotalExperience);
